module.exports = __webpack_public_path__ + "img/@work_bottom_off.40f641da.jpg";